import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const basic_user = {
  id: "admin",
  password: "pass",
  isAdmin: true,
  readonly: false,
  current_project: "bio 1",
  projects: ["bio 1", "bio image"],
  has_exam: false,
  exam_url: "",
};

export const login = createAsyncThunk(
  "user/login",
  async (_, { rejectWithValue }) => {
    try {
      localStorage.setItem("userInfo", JSON.stringify(basic_user));
      return basic_user;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const logout = createAsyncThunk("user/logout", () => {
  localStorage.removeItem("userInfo");
});

export const userAccountDetails = createAsyncThunk(
  "user/userAccountDetails",
  async (_, { rejectWithValue }) => {
    if (basic_user) {
      return basic_user;
    } else {
      return rejectWithValue("User not found");
    }
  },
);

const initialState = {
  userInfo: JSON.parse(localStorage.getItem("userInfo")) || null,
  loading: false,
  error: null,
  users: [],
};

// Create user slice
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // login
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.userInfo = action.payload;
        state.error = null;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // logout
      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.userInfo = null;
        state.error = null;
      })

      // get user account
      .addCase(userAccountDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(userAccountDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.userInfo = action.payload;
        state.error = null;
      })
      .addCase(userAccountDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default userSlice.reducer;
